import { render, staticRenderFns } from "./addAddres.vue?vue&type=template&id=27caede4"
import script from "./addAddres.vue?vue&type=script&lang=js"
export * from "./addAddres.vue?vue&type=script&lang=js"
import style0 from "./addAddres.vue?vue&type=style&index=0&id=27caede4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports